export enum HttpErrorCodes {
  E400 = <any>400,
  E401 = <any>401,
  E403 = <any>403,
  E404 = <any>404,
  E413 = <any>413,
  E422 = <any>422,
  E500 = <any>500,
  E502 = <any>502,
  E503 = <any>503,
  E504 = <any>504,
}
